import 'magnific-popup';
import 'slick-carousel';
/**
 * Created by chris on 12/04/2016.
 */
jQuery(document).ready(function ($) {
  if ($(window).width() < 960) {
    var headerHeight = '51';
  } else {
    var headerHeight = '107';
  }

  $('.hamburger').click(function () {
    $(this).toggleClass('is-active');
    $('#menu').toggleClass('is-active');
    $('html').toggleClass('is-opened');
    // close all sub menus
    $('.sub-menu').slideUp();
    $('.menu-item-has-children .arrow').removeClass('rotated');
  });

  $('.slick-carousel').slick({
    nextArrow : '<svg width="20" height="37" viewBox="0 0 20 37" fill="none" xmlns="http://www.w3.org/2000/svg" class="carousel-arrow next"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.93934 0.93934C1.52513 0.353553 2.47487 0.353553 3.06066 0.93934L19.5607 17.4393C20.1464 18.0251 20.1464 18.9749 19.5607 19.5607L3.06066 36.0607C2.47487 36.6464 1.52513 36.6464 0.93934 36.0607C0.353553 35.4749 0.353553 34.5251 0.93934 33.9393L16.3787 18.5L0.93934 3.06066C0.353553 2.47487 0.353553 1.52513 0.93934 0.93934Z" fill="white"/></svg>',
    prevArrow : '<svg width="20" height="37" viewBox="0 0 20 37" fill="none" xmlns="http://www.w3.org/2000/svg" class="carousel-arrow prev"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.5607 36.0607C18.9749 36.6464 18.0251 36.6464 17.4393 36.0607L0.939339 19.5607C0.353552 18.9749 0.353552 18.0251 0.939339 17.4393L17.4393 0.939339C18.0251 0.353554 18.9749 0.353554 19.5607 0.939339C20.1464 1.52513 20.1464 2.47487 19.5607 3.06066L4.12132 18.5L19.5607 33.9393C20.1464 34.5251 20.1464 35.4749 19.5607 36.0607Z" fill="white"/></svg>',
    appendArrows: '.slick-nav-container',
    autoplay : true,
    autoplaySpeed: 4000,
    speed: 500,
    centerMode: true,
    centerPadding: '25vw',
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          centerPadding: '180px',
        }
      },
      {
        breakpoint: 1000,
        settings: {
          centerPadding: '100px',
        }
      },
      {
        breakpoint: 796,
        settings: {
          centerPadding: '40px',
        }
      },
      {
        breakpoint: 548,
        settings: {
          centerMode: false,
        }
      },
    ]
  });
  $('.testimonials-carousel').slick({
    nextArrow : $('.test-arrow.next'),
    prevArrow : $('.test-arrow.prev'),
    autoplay : true,
    autoplaySpeed: 4000,
    speed: 500,
  });

  // mobile menu
  $('#mobile-menu li.menu-item-has-children').click(function () {
    $(this).find('.sub-menu').slideToggle();
    $(this).find('.arrow').toggleClass('rotated');
    // return false;
  });

  $('.popup a').magnificPopup({
    type: 'inline',
    midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
  });

  // Scrollto
  $('a.down-icon[href^="#"]').on('click', function (event) {
    var target = $(this.getAttribute('href'));
    if (target.length) {
      event.preventDefault();
      $('html, body')
          .stop()
          .animate(
              {
                scrollTop: target.offset().top - headerHeight,
              },
              500
          );
    }
  });

  $('a.down-icon-next[href^="#"]').on('click', function (event) {
    // var target = $(this.getAttribute('href'));
    var target = $(this)
        .closest('.content-area > *')
        .nextAll('.content-area > *');
    if (target.length) {
      event.preventDefault();
      $('html, body')
          .stop()
          .animate(
              {
                scrollTop: target.offset().top - headerHeight,
              },
              500
          );
    }
  });

  $('.menu-item a[href*="#"]').on('click', function (event) {
    //get hash
    var url = $(this).attr('href');
    var hash = url.split('#');
    var hashAftter = '#' + hash.pop();

    // get before hash
    var hashBefore = url.substr(0, url.indexOf('#'));
    var hashBefore = hashBefore.replace('https:', '');
    console.log(hashBefore);

    // before hash of current page
    var url2 = window.location.href;
    var hashBefore2 = url2.substr(0, url2.indexOf('#'));
    var url3 = hashBefore2.replace('http:', '');
    var url4 = url3.replace('https:', '');
    console.log(url4);

    // before hash of current page if it doesnt have #
    var url6 = url2.replace('http:', '');
    var url7 = url6.replace('https:', '');
    console.log(url7);

    if (hashBefore == url4 || hashBefore == url7) {
      event.preventDefault();
      $('html, body')
          .stop()
          .animate(
              {
                scrollTop: $(hashAftter).offset().top - headerHeight,
              },
              500
          );
    }

    // close menu
    $('.hamburger').removeClass('is-active');
    $('#menu').toggleClass('is-active');
    $('#menu').removeClass('is-active');
    $('html').removeClass('is-opened');
    // close all sub menus
    $('.sub-menu').slideUp();
    $('.menu-item-has-children .arrow').removeClass('rotated');
  });

  // external page
  if (location.hash) {
    var id = $(location.hash);
  }

  $(window).load(function () {
    if (location.hash) {
      $('html,body').animate(
          { scrollTop: id.offset().top - headerHeight },
          'linear'
      );
    }
  });

  //
  // Accordion
  //
  var allPanels = $('.accordion-items > li > div').hide();

  $('.accordion-items > li > a').click(function () {
    if (!$(this).hasClass('opened')) {
      $('.accordion-items > li > a').removeClass('opened');
      $('.accordion-items > li').removeClass('opened');
      $(this).addClass('opened');
      $(this).parent().addClass('opened');
      allPanels.slideUp();
      $(this).next().slideDown();
      $('.accordion-items > li > a .arrow').removeClass('rotated');
      $(this).find('.arrow').toggleClass('rotated');
    } else {
      $(this).removeClass('opened');
      $(this).parent().removeClass('opened');
      $(this).next().slideUp();
      $('.accordion-items > li > a .arrow').removeClass('rotated');
    }
    return false;
  });

  //
  // Equal Arrow Heights in Columns
  //
  $('.wp-block-columns').each(function () {
    // Cache the highest
    var highestBox = 0;

    // Select and loop the elements you want to equalise
    $(this)
        .find('.arrow-heading')
        .each(function () {
          // If this box is higher than the cached highest then store it
          if ($(this).height() > highestBox) {
            highestBox = $(this).height();
          }
        });

    // Set the height of all those children to whichever was highest
    $(this).find('.arrow-heading').height(highestBox);
  });
// Get the current URL
var currentUrl = window.location.href;

// Check if the URL has a query string parameter called "message"
if (currentUrl.indexOf("?message=") !== -1) {

  // Extract the message from the query string
  var message = currentUrl.substring(currentUrl.indexOf("?message=") + 9);

  // Find the div element to display the message
  var messageDiv = document.getElementById("subscribemessage");

  // Add the "show" class to the div element
  messageDiv.classList.add("show");

  // Set the message text in the div element
  messageDiv.innerText = message;

  // Wait for the message to be added to the DOM before scrolling
  setTimeout(function() {
    // Scroll to the bottom of the page
    window.scrollTo(0, document.body.scrollHeight);
  }, 100);
}


});

jQuery(function ($) {
  $('select').change(function () {
    var filter = $('#filter');
    $.ajax({
      url: filter.attr('action'),
      data: filter.serialize(), // form data
      type: filter.attr('method'), // POST
      beforeSend: function (xhr) {
        filter.find('button').text('Processing...'); // changing the button label
      },
      success: function (data) {
        filter.find('button').text('Apply filter'); // changing the button label back
        $('.latest-jobs').html(data); // insert data
      },
    });
    return false;
  });
});

jQuery(window).load(function ($) {
  jQuery('body').addClass('loaded');
});

jQuery(window).resize(function ($) {});

function sizetorow(divheight, target, adjustment) {
  var $ = jQuery;
  if ($(window).width() > 800) {
    var maxHeight = 0;

    $(target).css('min-height', maxHeight);
    var maxHeight = $(divheight).height() - adjustment;
    console.log(maxHeight);
    //$(target).each(function(){
    //
    //})
    setTimeout(function () {
      $(target).css('min-height', maxHeight);
    }, 600);
  }
}

function makesquare(target) {
  var $ = jQuery;
  var width = $(target).width();
  $(target).height(width);
}
